<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Messenger Einstellungen</h4>
      </div>
      <div class="card-body">
        <div class="alert alert-info">
          Um ein Telegram Bot zu erstellen suche auf Telegram den Account
          <b>BotFather</b> und sende die Nachricht <code>/newbot</code>.
          <br />
          Weitere Infos findest du
          <a target="_blank" href="https://core.telegram.org/bots#6-botfather"
            >hier</a
          >
        </div>
        <div v-if="telegramError" class="alert alert-warning">
          Es ist ein Fehler aufgetreten.
          <br />
          Bitte überprüfe den Telegram Bot Token.
        </div>
        <div class="form-group row">
          <div class="col-12">
            <toggle-switch
              label="Telegram"
              type="success"
              v-model="data.telegram"
            ></toggle-switch>
          </div>
        </div>
        <div class="form-group row">
          <col-label>Telegram Token</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.telegramToken"
            />
          </div>
        </div>
        <div class="form-group">
          <button @click="persist()" class="btn btn-primary">Speichern</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("setting/all").then(() => {
      this.data.telegram = Boolean(
        this.$store.getters["setting/key"]("telegram")
      );
      this.data.telegramToken = this.$store.getters["setting/key"](
        "telegramToken"
      );
      this.data.telegramBotName = this.$store.getters["setting/key"](
        "telegramBotName"
      );

      if (this.data.telegramToken && !this.data.telegramBotName) {
        this.telegramError = true;
      }
    });
  },
  methods: {
    persist() {
      this.telegramError = false;
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(response => {
        if (response.data.telegramToken && !response.data.telegramBotName) {
          this.telegramError = true;
        }
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  data() {
    return {
      data: {
        telegram: false,
        telegramToken: "",
        telegramBotName: ""
      },
      telegramError: false
    };
  }
};
</script>
